<template lang="pug">
  div(:class="'SwitcherIcon ' + (active ? ' is-active' : '')" @click="handleClick")
    .SwitcherIcon_toggle
    .SwitcherIcon_first
      SvgInline(src="pin")
    .SwitcherIcon_second
      SvgInline(src="picture")

</template>

<script>

import SvgInline from '@/components/SvgInline'

export default {
  components: { SvgInline },
  props: {
    active: true
  },
  methods: {
    handleClick () {
      this.$emit('toggle', !this.active)
    }
  }
}

</script>

<style lang="stylus" scoped>

  .SwitcherIcon
    height 35px
    padding 4px
    background-color $black
    overflow hidden
    border-radius 35px
    transition all 0.5s $ease
    cursor pointer

    &:hover

      .SwitcherIcon_toggle
        background-color $beige-l

    &_first
      position relative
      display inline-block
      width 35px
      height 35px

      svg
        position absolute
        width 50%
        top 50%
        left 50%
        transform translate(-50%, -50%)
        fill $black
        transition all 0.5s $ease

    &_second
      position relative
      display inline-block
      width 35px
      height 35px

      svg
        position absolute
        width 50%
        top 50%
        left 50%
        transform translate(-50%, -50%)
        fill #737373
        transition all 0.5s $ease

    &_toggle
      position absolute
      width 35px
      height 35px
      top 4px
      left 4px
      border-radius 50%
      background-color $beige
      transition all 0.5s $ease

    &.is-active

      .SwitcherIcon_first
        svg
          fill #737373

      .SwitcherIcon_second
        svg
          fill $black

      .SwitcherIcon_toggle
        transform translateX(100%)

</style>
